import cc from "classcat";

import styles from "./AlertsHeading.module.scss";

interface AlertsHeadingProps {
  heading?: string;
}

const AlertsHeading = ({ heading = "Default Text" }: AlertsHeadingProps) => (
  <header>
    <h4
      className={cc(["fontSize--heading4 fontFamily--default", styles.heading])}
    >
      {heading}
    </h4>
  </header>
);

export default AlertsHeading;
